const cargarTodasLasImagenes = require.context('../images/images-tour', true, /\.(png|jpe?g|svg)$/);

const obtenerImagenPrincipal = (nombreImagen) => {
  try {
    return cargarTodasLasImagenes(`./${nombreImagen}`); 
  } catch (error) {
    console.error(`Imagen principal no encontrada: ${nombreImagen}`);
    return null; 
  }
};

const obtenerRutaImagenesPaquete = (nombreCarpeta) => {
  return cargarTodasLasImagenes.keys()
    .filter((ruta) => ruta.includes(nombreCarpeta)) // Filtra imágenes en la subcarpeta
    .map(cargarTodasLasImagenes);
};

// Definición de los datos de los tours
export const tours = [
  {
    "id": 1,
    "tipo": "MEDIO DÍA",
    "backgroundTitle": "Lamas",
    "title": "Lamas",
    "subtitle": "La Ciudad Encantada de los Tres Pisos",
    "link": "lamas",
    "description": "Explora la ciudad encantada de los tres pisos: Lamas, donde la cultura quechua vive en cada rincón. Este recorrido por la plaza principal y las comunidades indígenas te conectará con la historia viva de la región. Desde su artesanía hasta el museo étnico, todo está lleno de leyendas y tradiciones milenarias que te transportarán en el tiempo.",
    "descriptionm": "Explora la ciudad encantada de los tres pisos: Lamas, donde la cultura quechua...",
    "clienteFotos": obtenerRutaImagenesPaquete('lamas'),
    "imagenPrincipal": obtenerImagenPrincipal('lamas.jpg'),
    "itinerario": {
      "cronograma": [
        {
          "titulo": "Salida desde Tarapoto",
          "hora": "03:00 PM",
          "actividades": [
            "• Visita al museo étnico, descubriendo la rica herencia cultural.",
            "• Recorrido por la plaza principal, admirando la arquitectura tradicional.",
            "• Participación en un taller de artesanía local."
          ]
        },
        {
          "titulo": "Retorno a Tarapoto",
          "hora": "06:30 PM",
          "actividades": [
            "• Regreso a Tarapoto",
            "• Tiempo libre para descansar"
          ]
        }
      ]
    }
  },
  {
    "id": 3,
    "tipo": "MEDIO DÍA",
    "backgroundTitle": "Mirador Tarapoto",
    "title": "Mirador Tarapoto",
    "subtitle": "Vistas de la Naturaleza al Máximo",
    "link": "mirador-tarapoto",
    "description": "Desde el Mirador de Tarapoto, disfruta de vistas impresionantes de la Amazonía, rodeado de montañas y paisajes verdes. Perfecto para capturar fotos únicas y vivir momentos inolvidables en medio.",
    "descriptionm": "Desde el Mirador de Tarapoto, disfruta de vistas impresionantes de la Amazonía...",
    "clienteFotos": obtenerRutaImagenesPaquete('mirador-tarapoto'),
    "imagenPrincipal": obtenerImagenPrincipal('mirador-tarapoto.jpg'),
    "itinerario": {
      "cronograma": [
        {
          "titulo": "Salida desde Tarapoto",
          "hora": "09:30 AM",
          "actividades": [
            "• Caminata hacia el mirador, con observación de flora y fauna amazónica.",
            "• Reflexión durante el recorrido de los pecados capitales.",
            "• Charla sobre mitos y leyendas locales de la Amazonía.",
            "• Tiempo para explorar, tomar fotos y descansar."
          ]
        },
        {
          "titulo": "Retorno a Tarapoto",
          "hora": "12:00 PM",
          "actividades": [
            "• Regreso a Tarapoto",
            "• Tiempo libre para descansar"
          ]
        }
      ]
    }
  },
  {
    "id": 2,
    "tipo": "MEDIO DÍA",
    "backgroundTitle": "Cascada AHUASHIYACU",
    "title": "Cascada Ahuashiyacu",
    "subtitle": "Un Refugio de Magia Natural",
    "link": "cascada-Ahuashiyacu",
    "description": "Descubre la magia de la Cascada Ahuashiyacu, un lugar escondido en la selva con poderes curativos según la leyenda. Perfecta para desconectar y sumergirte en la naturaleza, esta caminata corta ofrece paisajes llenos de vida y tranquilidad.",
    "descriptionm": "Descubre la magia de la Cascada Ahuashiyacu, un lugar escondido en la selva con poderes...",
    "clienteFotos": obtenerRutaImagenesPaquete('cascada-hushiaco'),
    "imagenPrincipal": obtenerImagenPrincipal('cascada-hushiaco.jpg'),
    "itinerario": {
      "cronograma": [
        {
          "titulo": "Salida desde Tarapoto",
          "hora": "09:30 AM",
          "actividades": [
            "• Breve caminata a través de senderos naturales rodeados de flora exótica.",
            "• Meditación y tiempo de reflexión junto a la cascada.",
            "• Oportunidades para fotografía de la impresionante caída de agua.",
            "• Baño al aire libre."
          ]
        },
        {
          "titulo": "Retorno a Tarapoto",
          "hora": "11:30 AM",
          "actividades": [
            "• Regreso a Tarapoto",
            "• Tiempo libre para descansar"
          ]
        }
      ]
    }
  },
  {
    id: 4,
    "tipo": "TODO EL DÍA",
    "backgroundTitle": "Alto Mayo",
    "title": "Alto Mayo",
    "subtitle": "Naturaleza Viva",
    "link": "alto-mayo",
    "description": "Embárcate en una aventura por el maravilloso mundo de Alto Mayo, una alegría natural llena de biodiversidad y cultura viva.",
    "descriptionm": "Embárcate en una aventura por el maravilloso mundo de Alto Mayo, llena de biodiversidad...",
    "clienteFotos": obtenerRutaImagenesPaquete('alto-mayo'),
    "imagenPrincipal": obtenerImagenPrincipal('alto-mayo.jpg'),
    "itinerario": {
      "cronograma": [
        {
          "titulo": "Salida desde Tarapoto",
          "hora": "07:30 AM",
          "actividades": [
            "• Senderismo por la reserva.",
            "• Encuentro con comunidades para aprender sobre sus tradiciones.",
            "• Observación de flora y fauna única de la región.",
            "• Visitaras los diversos productos de fabricación artesanal."
          ]
        },
        {
          "titulo": "Retorno a Tarapoto",
          "hora": "04:00 PM",
          "actividades": [
            "• Regreso a Tarapoto",
            "• Relajación en el hotel"
          ]
        }
      ]
    }
  },
  {
    id: 5,
    tipo: 'TODO EL DÍA',
    backgroundTitle: 'Carpishuyacu',
    title: 'Cascada Carpishuyacu',
    subtitle: 'Un Oasis Escondido',
    link: 'carpishuyacu',
    description: 'Descubre un oasis escondido en la selva amazónica: la Cascada Carpishuyacu. Un paraíso natural perfecto para nadar, relajarse y disfrutar de la belleza inexplorada de la Amazonía.',
    descriptionm: 'Descubre un oasis escondido en la selva amazónica: la Cascada Carpishuyacu...',
    clienteFotos: obtenerRutaImagenesPaquete('carpishuyacu'),
    imagenPrincipal: obtenerImagenPrincipal('carpishuyacu.jpg'),
    itinerario: {
      cronograma: [
        {
          titulo: "Salida desde Tarapoto",
          hora: "08:00 AM",
          actividades: [
            "• Natación en las aguas cristalinas de la cascada.",
            "• Tiempo libre para explorar y disfrutar del entorno.",
            "• Picoteo de frutas y refrigerios locales."
          ]
        },
        {
          titulo: "Retorno a Tarapoto",
          hora: "03:00 PM",
          actividades: [
            "• Regreso a Tarapoto",
            "• Relajación después de la aventura"
          ]
        }
      ]
    }
  },
  {
    id: 6,
    "tipo": "TODO EL DÍA",
    "backgroundTitle": "Laguna Azul",
    "title": "Laguna Azul",
    "subtitle": "Un Paraíso Acuático",
    "link": "laguna-azul",
    "description": "Navega por las aguas encantadas de la Laguna Azul, un paraíso escondido lleno de leyendas amazónicas sobre sirenas y criaturas fantásticas.",
    "descriptionm": "Navega por las aguas encantadas de la Laguna Azul, un paraíso escondido...",
    "clienteFotos": obtenerRutaImagenesPaquete('laguna-azul'),
    "imagenPrincipal": obtenerImagenPrincipal('laguna-azul.jpg'),
    "itinerario": {
      "cronograma": [
        {
          "titulo": "Partida hacia la laguna",
          "hora": "08:00 AM",
          "actividades": [
            "• Paseo en bote por la laguna.",
            "• Actividades acuáticas como kayak o natación.",
            "• Degustación de platos típicos amazónicos."
          ]
        },
        {
          "titulo": "Retorno a Tarapoto",
          "hora": "04:00 PM",
          "actividades": [
            "• Regreso a Tarapoto",
            "• Descanso en el hotel"
          ]
        }
      ]
    }
  }
];
